import * as React from "react";
import { RowWrapper, RowWrapperProps } from "../wrapper/wrapper";

interface Props extends RowWrapperProps {}

export const RowBlank = (props: Props) => (
    <RowWrapper {...props} children={null} />
);
